import { Grid, useEventCallback } from '@mui/material';
import { ForeignMunicipality } from 'shell/components/shared/event-form/form-foreign-event';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import MunicipalityForeignList, {
  MunicipalityForeignAnprVM,
} from 'shell/components/shared/municipality-foreign-list';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';

interface FormForeignEventProps {
  form: ForeignMunicipality | undefined | null;
  handleChange: (form: ForeignMunicipality) => void;
  errors?: FormikErrors<ForeignMunicipality>;
  touched?: FormikTouched<ForeignMunicipality>;
  disabled?: boolean;
}

const FormForeignEventComponent = ({
  form,
  handleChange,
  errors,
  touched,
  disabled = false,
}: FormForeignEventProps): React.ReactElement => {
  const onChangeForeignState = useEventCallback((state: ForeignStateVM | null | undefined) => {
    handleChange({
      ...(form || {}),
      stateId: state?.id,
      stateDescription: state?.value,
      istatCode: state?.istatCode,
    });
  });

  const onChangeForeignMunicipality = useEventCallback(
    (municipality: MunicipalityForeignAnprVM | undefined | null) => {
      handleChange({
        ...(form || {}),
        municipalityId: municipality?.id,
        municipalityDescription: municipality?.description,
        province: municipality?.province,
      });
    }
  );

  return (
    <>
      <Grid item xs={12} md={4}>
        <ForeignStateList
          value={
            form?.stateId
              ? {
                  id: form?.stateId || '',
                  value: form?.stateDescription || '',
                }
              : null
          }
          onChange={onChangeForeignState}
          label="Stato estero"
          id="foreignState"
          error={touched?.stateId && Boolean(errors?.stateId)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MunicipalityForeignList
          value={
            form?.municipalityId
              ? {
                  id: form?.municipalityId,
                  description: form?.municipalityDescription || '',
                  province: '',
                }
              : null
          }
          foreignStateIstatCode={form?.istatCode}
          onChange={onChangeForeignMunicipality}
          label="Comune estero"
          id="foreignMunicipality"
          disabled={!form?.istatCode || disabled}
          error={touched?.municipalityId && Boolean(errors?.municipalityId)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={form?.province || ''}
          error={touched?.province && Boolean(errors?.province)}
          helperText={errors?.province}
        />
      </Grid>
    </>
  );
};

FormForeignEventComponent.displayName = 'Form autorità estera';

const FormForeignEventMemo = memo(FormForeignEventComponent);

export default FormForeignEventMemo;
